// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import Organization from "../module/Organization/Component/organization";
// import MachineRoutes from "../module/MachineConfiguration/machineRoutes";
// import UnderConstruction from "../../BasicComponent/Components/underConstruction";
// import Role from "../module/Role/Component/rolecomponent";
// import User from "../module/User/Component/user";
// import Product from "../module/Product/Component/product";
// import IotGateWayComponent from "../module/IotGateWay/Components/iotGateWayComponent";
// import UserAccess from "../module/UserAccess/Component/userAccess";

// function ConfigurationRoutes() {
//   return (
//     <Routes>
//       <Route path="/" element={<Organization />} />
//       <Route path="product/*" element={<Product />} />
//       <Route path="iot-gateway/*" element={<IotGateWayComponent />} />
//       <Route path="machine/*" element={<MachineRoutes />} />
//       <Route path="role/*" element={<Role />} />
//       <Route path="user/*" element={<User />} />
//       <Route path="user-access/*" element={<UserAccess />} />
//     </Routes>
//   );
// }

// export default ConfigurationRoutes;

import React from "react";
import { Route, Routes } from "react-router-dom";
import Organization from "../module/Organization/Component/organization";
import MachineRoutes from "../module/MachineConfiguration/machineRoutes";
import Role from "../module/Role/Component/rolecomponent";
import User from "../module/User/Component/user";
import Product from "../module/Product/Component/product";
import IotGateWayComponent from "../module/IotGateWay/Components/iotGateWayComponent";
import UserAccess from "../module/UserAccess/Component/userAccess";
import ProtectedRoute from "../../components/ProtectedRoute";

function ConfigurationRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute menuKey="CONFIG_ORGANIZATION">
            <Organization />
          </ProtectedRoute>
        }
      />
      <Route
        path="product/*"
        element={
          <ProtectedRoute menuKey="CONFIG_PRODUCT">
            <Product />
          </ProtectedRoute>
        }
      />
      <Route
        path="iot-gateway/*"
        element={
          <ProtectedRoute menuKey="CONFIG_IOT_GATEWAY">
            <IotGateWayComponent />
          </ProtectedRoute>
        }
      />
      <Route
        path="machine/*"
        element={
          <ProtectedRoute menuKey="CONFIG_MACHINE">
            <MachineRoutes />
          </ProtectedRoute>
        }
      />
      <Route
        path="role/*"
        element={
          <ProtectedRoute menuKey="CONFIG_ROLE">
            <Role />
          </ProtectedRoute>
        }
      />
      <Route
        path="user/*"
        element={
          <ProtectedRoute menuKey="CONFIG_USER">
            <User />
          </ProtectedRoute>
        }
      />
      {/* User Access is only for Admin / Super Admin — no menuKey guard needed
          since the sidebar already hides the link for non-admins */}
      <Route path="user-access/*" element={<UserAccess />} />
    </Routes>
  );
}

export default ConfigurationRoutes;